/**
 * @desc 待补料信息提交
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(body: defs.tms.TransportDblRequestDto, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/transportMaster/dblTransportMaster`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
